import { buildCollection } from "@firecms/core";

export const gameOptionsCollection = buildCollection({
  id: "game_options",
  name: "Game Options",
  path: "game_options",
  icon: "auto_stories",
  group: "Game Options",
  textSearchEnabled: true,
  properties: {
    name: {
      dataType: "string",
      name: "Name",
      validation: {
        required: true,
      },
    },
    options: {
      dataType: "array",
      name: "Options",
      oneOf: {
        properties: {
          option: {
            dataType: "map",
            properties: {
              short_text: {
                dataType: "string",
                name: "Short Text",
                validation: {
                  required: true,
                },
              },
              description: {
                dataType: "string",
                name: "Description",
                validation: {
                  required: true,
                },
              },
            },
          },
        },
      },
    },
  },
});
